import {Space} from "@mantine/core";
import React, {useState} from "react";
import {SystemMemoryProps} from "../../../models/SystemMemoryProps";
import {TableEditor} from "../../TableEditor";
import {IconCalendar, IconAt, IconLogin} from "@tabler/icons-react";
import {ApiDataHelper} from "../../../data/ApiDataHelper";
import {AdminUsersAccessCodesModel} from "../../../models/admin/users/AdminUsersAccessCodesModel";

export function AdminUsersAccessCodes(memory: SystemMemoryProps) {

    return (
        <>
            <Space h="lg"/>
            {TableEditor<AdminUsersAccessCodesModel>({
                headers: [
                    {title: 'Access Code', key: 'code', type: 'text', viewOnly: true, icon: <IconLogin size="0.8rem"/>},
                    {title: 'Email', key: 'recipientEmail', type: 'text', viewOnly: false, icon: <IconAt size="0.8rem"/>},
                    {title: 'Expires', key: 'expires', type: 'text', viewOnly: true, icon: <IconCalendar size="0.8rem"/>},
                    {title: 'Created', key: 'created', type: 'text', viewOnly: true, icon: <IconCalendar size="0.8rem"/>}
                ],
                apiObject: new ApiDataHelper(memory),
                getURL: '/auth/admin/access-codes',
                postURL: {url: '/auth/admin/create-access-code', keys: ['recipientEmail']},
                putURL: undefined,
                delURL: undefined
            })}
        </>
    );
}